import { minBreakpoints } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

export const partnerPageHeaderWrapper = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      background-color: var(--brand-purple-5);
    `,
  )}
`;
